/* Sprint Crow — BOGOS Mix & Match: "Bundle deal" + live "Save €X" pills */
(function () {
  var root = document.getElementById('bogos-mix-match-view');
  if (!root) return;
  var DEAL = root.getAttribute('data-sc-deal') || 'Bundle deal';
  var SAVE = root.getAttribute('data-sc-save') || 'Save';
  var TAG_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';

  function num(t) {
    t = (t || '').replace(/[^\d.,]/g, '');
    if (t.indexOf(',') > -1 && t.indexOf('.') > -1) t = t.replace(/,/g, '');
    else t = t.replace(',', '.');
    return parseFloat(t) || 0;
  }

  function update() {
    var w = root.querySelector('.bogos-mix-match-widget');
    var head = w && w.querySelector('.bogos-mix-match-widget-header');
    if (!head) return;
    var top = head.querySelector('.sc-bm-top');
    if (!top) {
      top = document.createElement('div');
      top.className = 'sc-bm-top';
      top.innerHTML = '<span class="sc-bm-deal">' + TAG_SVG + '<span></span></span><span class="sc-bm-save" hidden></span>';
      top.querySelector('.sc-bm-deal span').textContent = DEAL;
      head.insertBefore(top, head.firstChild);
    }
    var save = top.querySelector('.sc-bm-save');
    var d = w.querySelector('.bogos-mix-match-total-discount-price');
    var o = w.querySelector('.bogos-mix-match-total-original-price');
    var diff = d && o ? num(o.textContent) - num(d.textContent) : 0;
    if (diff > 0.004) {
      var txt = SAVE + ' ' + d.textContent.trim().replace(/[\d.,]+/, diff.toFixed(2));
      if (save.textContent !== txt) save.textContent = txt;
      if (save.hidden) save.hidden = false;
    } else if (!save.hidden) {
      save.hidden = true;
    }
  }

  new MutationObserver(update).observe(root, { childList: true, subtree: true, characterData: true });
  update();

  /* product picker modal: subtitle, "€X → €37.63 per tee" pill, per-card bundle price */
  var EACH = parseFloat(root.getAttribute('data-sc-each') || '0');
  var SUB = root.getAttribute('data-sc-sub') || '';
  var PER = root.getAttribute('data-sc-per') || 'per tee';
  if (!EACH) return;

  function money(sample, n) { return sample.trim().replace(/[\d.,]+/, n.toFixed(2)); }

  function modal() {
    var m = document.getElementById('bogos-mix-match-main-collection-popup-container');
    if (!m) return;
    var head = m.querySelector('.bogos-mix-match-collection-popup-header');
    var prices = m.querySelectorAll('.bogos-mix-match-card-price');
    if (!head || !prices.length) return;
    var max = 0, sample = '';
    prices.forEach(function (el) {
      var orig = el.getAttribute('data-sc-orig');
      if (!el.querySelector('.sc-mm-n')) {
        orig = el.textContent.trim();
        el.setAttribute('data-sc-orig', orig);
        el.innerHTML = '';
        var s = document.createElement('s'); s.textContent = orig;
        var b = document.createElement('b'); b.className = 'sc-mm-n'; b.textContent = money(orig, EACH);
        el.appendChild(s); el.appendChild(b);
      }
      var v = num(orig);
      if (v > max) { max = v; sample = orig; }
    });
    if (!max) return;
    var pct = Math.round((1 - EACH / max) * 100);
    var sub = head.querySelector('.sc-mm-sub');
    if (!sub) {
      sub = document.createElement('div'); sub.className = 'sc-mm-sub';
      head.appendChild(sub);
    }
    var subHtml = SUB.replace('{pct}', pct);
    if (sub.innerHTML !== subHtml) sub.innerHTML = subHtml;
    var pill = head.querySelector('.sc-mm-pill');
    if (!pill) {
      pill = document.createElement('div'); pill.className = 'sc-mm-pill';
      pill.innerHTML = TAG_SVG.replace(/14/g, '22') + '<s></s><span class="sc-mm-arrow">→</span><span class="sc-mm-new"><b></b><small></small></span>';
      head.appendChild(pill);
    }
    var t1 = money(sample, max), t2 = money(sample, EACH);
    if (pill.querySelector('s').textContent !== t1) pill.querySelector('s').textContent = t1;
    if (pill.querySelector('b').textContent !== t2) pill.querySelector('b').textContent = t2;
    if (pill.querySelector('small').textContent !== PER) pill.querySelector('small').textContent = PER;
  }

  function watchModal() {
    var m = document.getElementById('bogos-mix-match-main-collection-popup-container');
    if (!m) return false;
    new MutationObserver(modal).observe(m, { childList: true, subtree: true, characterData: true });
    modal();
    return true;
  }
  if (!watchModal()) {
    var tries = 0, iv = setInterval(function () { if (watchModal() || ++tries > 40) clearInterval(iv); }, 500);
  }
})();
